<template>
  <div
    class="px-4 lg:px-0 mt-2"
    :class="{ 'theme-dark': !nightMode, content: nightMode }"
  >
    <div v-if="graphs.length > 0" class="flex flex-col">
      <div class="text-center text-2xl my-4">
        {{ $t("report_type_title") }}
      </div>
      <div class="form-report grid grid-cols-1" v-if="this.fValues.length > 0">
        <div>
          <form>
            <div
              class="report_form block lg:flex justify-center"
              :class="{ 'regla-borde-report': !$isMobile() }"
              v-if="typeForm !== ''"
            >
              <div
                class="
                  flex flex-cols
                  items-center
                  rounded
                  px-2
                  py-4
                  mb-10
                  lg:px-10 lg:mb-0
                "
                :class="{
                  'border border-black': nightMode,
                  'border border-white': !nightMode,
                }"
              >
                <label for="sensors" class="mr-4">{{ $t("sensors") }}</label>
                <multiselect
                  selectLabel=""
                  deselectLabel=""
                  selectedLabel=""
                  v-model="nReport.sensors"
                  :options="fValues"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :placeholder="$t('reports_placeholder_sensors')"
                  :preselect-first="false"
                >
                </multiselect>
              </div>
              <div
                class="
                  grid grid-cols-1
                  lg:grid-cols-2
                  rounded
                  px-2
                  py-2
                  lg:py-10
                  items-center
                "
                :class="{
                  'border border-black': nightMode,
                  'border border-white': !nightMode,
                }"
              >
                <div
                  class="mr-0 px-0 lg:mr-2 lg:px-10"
                  :class="{
                    'border-b lg:border-b-0 lg:border-r border-black':
                      nightMode,
                    'border-b lg:border-b-0 lg:border-r border-white':
                      !nightMode,
                  }"
                >
                  <div class="text-center mb-4 text-semibold text-xl">
                    {{ $t("reports_title_generate") }}
                  </div>
                  <div class="mb-0 lg:mb-4">
                    <input
                      type="radio"
                      id="type-form1"
                      value="generar"
                      v-model="typeForm"
                    />
                    <label
                      class="mx-2 text-sm lg:text-xl font-bold"
                      for="type-form1"
                      >{{ $t("reports_button_generate") }}</label
                    >
                  </div>
                  <div
                    class="
                      my-2
                      mb-0
                      lg:mb-4
                      block
                      lg:flex lg:justify-between lg:items-center
                    "
                  >
                    <label for="period" class="w-1/3 text-sm lg:text-base">{{
                      $t("reports_form_start")
                    }}</label>
                    <datepicker
                      :disabled="typeForm !== 'generar'"
                      :format="customFormatter"
                      :disabled-dates="disabledDates"
                      v-model="nReport.start_date"
                      class="w-2/3 text-black datepicker-parent"
                      :input-class="
                        nightMode
                          ? 'reports-select-dark datepicker-width'
                          : 'reports datepicker-width'
                      "
                      :style="'--picker-width:' + getPickerWidth()"
                    ></datepicker>
                  </div>
                  <div
                    class="
                      my-2
                      block
                      lg:flex lg:justify-between lg:items-center
                    "
                  >
                    <label for="period" class="w-1/3 text-sm lg:text-base">{{
                      $t("reports_form_end")
                    }}</label>
                    <datepicker
                      :disabled="typeForm !== 'generar'"
                      :format="customFormatter"
                      :disabled-dates="disabledDates"
                      v-model="nReport.end_date"
                      class="w-2/3 text-black datepicker-parent"
                      :input-class="
                        nightMode
                          ? 'reports-select-dark datepicker-width'
                          : 'reports datepicker-width'
                      "
                      :style="'--picker-width:' + getPickerWidth()"
                    ></datepicker>
                  </div>
                </div>
                <div class="mt-4 lg:mt-0 px-0 lg:px-10">
                  <div class="text-center mb-4 text-semibold text-xl">
                    {{ $t("reports_title_program") }}
                  </div>
                  <div class="mb-0 lg:mb-4">
                    <input
                      type="radio"
                      id="type-form2"
                      value="programar"
                      v-model="typeForm"
                    />
                    <label
                      class="mx-2 text-base lg:text-xl font-bold"
                      for="type-form2"
                      >{{ $t("add") }}</label
                    >
                  </div>
                  <div
                    class="
                      my-2
                      mb-0
                      lg:mb-4
                      flex flex-col
                      lg:flex-row lg:justify-between lg:items-center
                    "
                  >
                    <label
                      for="frequency"
                      class="w-1/4 text-sm lg:text-base break-normal"
                      >{{ $t("frequency") }}:
                    </label>
                    <select
                      :disabled="typeForm === 'generar'"
                      name="select"
                      v-model="nReport.frequency"
                      class="w-2/4"
                      id="alias"
                      :class="{
                        'reports-select-dark': nightMode,
                        reports: !nightMode,
                      }"
                    >
                      <option value="daily">
                        {{ $t("reports_frequency_daily") }}
                      </option>
                      <option value="weekly">
                        {{ $t("reports_frequency_weekly") }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="
                      my-2
                      block
                      lg:flex lg:justify-between lg:items-center
                    "
                  >
                    <label for="enddate" class="w-1/3 text-sm lg:text-base"
                      >{{ $t("end_date") }}:</label
                    >
                    <datepicker
                      :disabled="typeForm === 'generar'"
                      :format="customFormatter"
                      :disabled-dates="disabledDates2"
                      v-model="nReport.end_period"
                      class="w-2/3 text-black datepicker-parent"
                      :input-class="
                        nightMode
                          ? 'reports-select-dark datepicker-width'
                          : 'reports datepicker-width'
                      "
                      :style="'--picker-width:' + getPickerWidth()"
                    ></datepicker>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div
            v-if="typeForm !== ''"
            class="mt-10 grid grid-cols-1 lg:grid-cols-2"
            :class="{ 'regla-borde-report': !$isMobile() }"
          >
            <div>
              <h2>{{ $t("type_of_report") }}</h2>
              <div class="grid grid-cols-1 lg:grid-cols-3 mt-2">
                <div class="type-reports col-span-2">
                  <div
                    class="
                      grid grid-cols-1
                      md:grid-cols-2
                      lg:grid-cols-2
                      gap-2
                      text-sm
                      px-2
                      lg:px-0
                    "
                  >
                    <div>
                      <div class="my-2 flex items-center">
                        <input
                          type="radio"
                          name="typeR"
                          id="type-report1"
                          value="L1"
                          v-model="nReport.type"
                        />

                        <label class="mx-2" for="type-report1"
                          >{{ $t("type") }} 1</label
                        >
                        <v-popover v-if="$isMobile()" offset="16">
                          <button class="tooltip-target b3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-info-circle"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                              />
                              <path
                                d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                              />
                            </svg>
                          </button>
                          <template slot="popover">
                            <div class="sm:h-4">
                              <div
                                style="margin: auto; display: inline-block"
                                v-html="$t('type_1_desc')"
                              ></div>
                            </div>
                          </template>
                        </v-popover>
                        <button
                          v-else
                          v-tooltip.auto="{
                            content: msg,
                          }"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-info-circle"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                            />
                            <path
                              d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                            />
                          </svg>
                        </button>
                      </div>
                      <div>
                        <img
                          class="w-4/5"
                          src="https://i.imgur.com/UXF62Q0.png"
                        />
                      </div>
                    </div>
                    <div>
                      <div class="my-2 flex items-center">
                        <input
                          :disabled="!isPremium"
                          type="radio"
                          id="type-report2"
                          value="L2"
                          v-model="nReport.type"
                        />
                        <label class="mx-2" for="type-report2"
                          >{{ $t("type") }} 2</label
                        >
                        <v-popover v-if="$isMobile()" offset="16">
                          <button class="tooltip-target b3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-info-circle"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                              />
                              <path
                                d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                              />
                            </svg>
                          </button>
                          <template slot="popover">
                            <div class="sm:h-4">
                              <div
                                style="margin: auto; display: inline-block"
                                v-html="$t('type_2_desc')"
                              ></div>
                            </div>
                          </template>
                        </v-popover>
                        <button
                          v-else
                          v-tooltip.auto="{
                            content: msg2,
                          }"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-info-circle"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                            />
                            <path
                              d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                            />
                          </svg>
                        </button>
                      </div>
                      <div>
                        <img
                          class="w-4/5"
                          src="https://i.imgur.com/zfbxzWz.png"
                        />
                      </div>
                      <div v-if="!isPremium" class="mt-2">
                        {{ $t("reports_premium_msg") }}
                        <a
                          class="underline text-blue"
                          href="mailto:urbanbrain@siarq.com"
                          >urbanbrain@siarq.com</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-6">
                <div
                  v-if="typeForm === 'programar'"
                  class="flex flex-cols items-center justify-between mb-4"
                >
                  <button
                    class="
                      cluster-button cluster-gray
                      text-xs
                      lg:text-base
                      px-4
                      py-2
                      rounded-sm
                      text-white
                    "
                    :disabled="!validateProgram(nReport)"
                    @click="createReport()"
                  >
                    {{ $t("add") }}
                  </button>
                </div>
                <div
                  v-if="typeForm !== 'programar'"
                  class="mt-0 col-span-2 lg:col-auto"
                >
                  <button
                    class="
                      px-4
                      py-2
                      rounded-sm
                      text-xs
                      lg:text-base
                      flex
                      justify-center
                      items-center
                    "
                    :style="[
                      nReport.type
                        ? { background: '#fbb03b', color: 'white' }
                        : { background: '#fbb03b', color: 'white' },
                    ]"
                    :disabled="!validateReport(nReport)"
                    @click="generateReport()"
                  >
                    <div class="my-1">{{ $t("reports_button_generate") }}</div>
                    <div v-if="!printed && print === true">
                      <FacebookLoader
                        :color="'#FFFFFF'"
                        :size="24"
                        class="ml-2 my-1"
                      />
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div>
              <div
                v-if="reportList && reportList.length > 0"
                class="table-reports my-6 lg:my-0 flex justify-center"
              >
                <div class="cluster tablewidth">
                  <div class="block border border-white">
                    <div
                      class="
                        text-start
                        items-center
                        py-2
                        px-4
                        text-xs
                        sm:text-sm
                        font-medium
                        flex
                      "
                      :class="{
                        'cluster-gray': !nightMode,
                        'cluster-light': nightMode,
                        flex: $isMobile(),
                        flex: !$isMobile(),
                      }"
                    >
                      <div
                        class="title"
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                      >
                        {{ $t("reports_table_id") }}
                      </div>
                      <div
                        class="title"
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                        v-if="!$isMobile()"
                      >
                        {{ $t("reports_table_endDate") }}
                      </div>
                      <div
                        class="title break-words"
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                      >
                        {{ $t("reports_table_frequency") }}
                      </div>
                      <div
                        class="title"
                        v-if="!$isMobile()"
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                      >
                        {{ $t("reports_table_active") }}
                      </div>
                      <div
                        class="title"
                        v-if="!$isMobile()"
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                      >
                        {{ $t("reports_table_type") }}
                      </div>
                      <div
                        class="title"
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                      >
                        {{ $t("reports_table_sensors") }}
                      </div>
                      <div
                        class="title hidden"
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                      >
                        {{ $t("reports_table_delete") }}
                      </div>
                    </div>
                    <div
                      class="px-4 py-2 text-xs sm:text-sm text-start flex"
                      style="align-items: center"
                      v-for="(item, index) in reportList"
                      :key="item.id"
                      :class="{
                        'cluster-gray': index % 2 !== 0,
                        'cluster-light': nightMode && index % 2 !== 0,
                        flex: $isMobile(),
                        flex: !$isMobile(),
                      }"
                    >
                      <div
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                      >
                        {{ item.id }}
                      </div>
                      <div
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                        v-if="!$isMobile()"
                      >
                        {{ item.endDate }}
                      </div>
                      <div
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                      >
                        {{
                          item.frequency == "daily"
                            ? $t("reports_frequency_daily")
                            : $t("reports_frequency_weekly")
                        }}
                      </div>
                      <div
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                        v-if="!$isMobile()"
                      >
                        {{
                          item.active === true
                            ? $t("report_active_yes")
                            : $t("report_active_no")
                        }}
                      </div>
                      <div
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                        v-if="!$isMobile()"
                      >
                        {{ item.type }}
                      </div>
                      <div
                        :style="$isMobile() ? 'width:33.3%;' : 'width:16.6%;'"
                        class="
                          ml-0
                          flex
                          items-center
                          justify-between
                          col-span-2
                          lg:col-span-1
                        "
                      >
                        <ul>
                          <li
                            v-if="item.sensors.length == sensorCounter"
                            style="display: inline"
                          >
                            {{ $t("reports_table_all") }}
                          </li>
                          <li
                            v-else
                            style="display: inline"
                            v-for="(s, index) in item.sensors"
                            :key="s.id"
                          >
                            {{ s.name
                            }}<span v-if="index + 1 < item.sensors.length"
                              >,&nbsp;</span
                            >
                          </li>
                        </ul>
                        <div class="flex items-center justify-center">
                          <button @click="deleteProgramReport(index)">
                            <div class="w-6">
                              <img :src="require(`@/assets/icon-delete.png`)" />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="error" class="text-red-400">
                  {{ $t("reports_message_error_fields") }}
                </div>
              </div>
              <div v-else>{{ $t("reports_message_empty") }}</div>
              <div v-if="!receiveReports" style="color:#e14242">{{ $t("reports_warning_footer") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center my-32 sm:my-48 text-2xl">
        {{ $t("reports_message_error_nosensors") }}
      </div>

      <div :class="{ 'regla-borde-report': !$isMobile() }">

        <div v-if="typeForm !== ''" class="my-6 mr-4 mb-2">
          {{ $t("contact_reports") }}
          <a class="underline text-blue" href="mailto:urbanbrain@siarq.com"
            >urbanbrain@siarq.com</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Vista de Reportes
 * --------------------------------------------
 *
 * Vista que permite planificar un reporte para generar o programar un reporte.
 * Hay dos tipos de reportes disponibles ( 1 es premium) y una tabla donde se muestran los reportes programados.
 * Se usan los componentes de loader, de datePicker(para que sea igual en safari que en chrome) y el multiselect para seleccionar diferentes sensores.
 *
 */
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";

import { FacebookLoader } from "vue-spinners-css";
import { getListSolarHubs, submitReport } from "@/utils/SolarHubService.js";
import { delReport, createProgramReport } from "@/utils/ReportService.js";
import { getProfile } from "@/utils/ProfileService.js";

import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    Multiselect,
    FacebookLoader,
    Datepicker,
  },
  props: ["nightMode", "selectedHub"],
  data() {
    return {
      type: "",
      typeForm: "generar",
      msg: this.$i18n.t("type_1_desc"),
      msg2: this.$i18n.t("type_2_desc"),
      graphs: {},
      fValues: [],
      error: false,
      reports: {},
      startDate: null,
      endDate: null,
      nReport: {
        sensors: [],
      },
      printed: false,
      print: false,
      arrFiltered: [],
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      disabledDates: {
        from: new Date(Date.now()),
        to: new Date(2019, 12, 1),
      },
      disabledDates2: {
        to: new Date(Date.now() - 3600 * 1000 * 24),
      },
      sensorCounter: 0,
      isPremium: false,
      showForm: false,
      receiveReports: false,
    };
  },
  /**
   * Método que obtiene los datos del perfil y amira si el usuario es premium para permitirle seleccionar el tipo de reporte 2.
   * Obtenemos también la lista de solarhubs para poder seleccionar los sensores del multiselect. 
   */
  async beforeMount() {
    let profile = await getProfile();
    this.isPremium = profile.isPremium;
    this.receiveReports = profile.receiveReports;
    const data = await getListSolarHubs(
      this.currentCluster[0].id,
      this.currentCluster[0].solarHubs[this.selectedHub].id
    );
    this.graphs = await data[this.selectedHub].sensors;
    this.fValues = [];
    this.sensorCounter = 0;
    if (this.sensorCounter == 0) {
      this.fValues.push({ name: "All" });
    }
    this.graphs.forEach((element) => {
      if (
        element.name !== "I_BATT_000" &&
        element.name !== "PWM_Led_000" &&
        element.name !== "SoC_000" &&
        element.influxId !== "T" &&
        element.influxId !== "RH"
      ) {
        this.sensorCounter++;
        this.fValues.push({ name: element.name });
      }
    });
    this.loadingTableReports();
  },
  methods: {
    ...mapMutations("reports", ["saveReport", "updateReportList"]),
    ...mapActions("reports", ["loadReports"]),

  /**
   * Método que devuelve una width en el picker dependiendo de si se muestra en versión movil o no.
   */
    getPickerWidth() {
      return this.$isMobile() ? "85vw" : "18vw";
    },
    customFormatter(date) {
      let p = new Date(date);
      return this.formatDate(p);
    },
  /**
   * Método para filtrar los sensores cuando se van seleccionando en el multiselect.
   */
    filterBySelect() {
      var arrayFil = [];
      if (this.nReport.sensors.filter((e) => e.name === "All").length > 0) {
        var fValuesFilt = [];
        fValuesFilt = this.fValues.filter((e) => e.name !== "All");
        this.graphs.forEach((element) => {
          fValuesFilt.forEach((el) => {
            if (el.name === element.name && element.type === "line") {
              arrayFil.push(element);
            }
          });
        });
      } else {
        this.graphs.forEach((element) => {
          this.nReport.sensors.forEach((el) => {
            if (el.name === element.name && element.type === "line") {
              arrayFil.push(element);
            }
          });
        });
      }
      return arrayFil;
    },
  /**
   * Método para generar un reporte con los datos de planificación.
   * Se necesita, fecha inicial, fecha final. 
   * Se obtienen los datos a partir de fecha inicial, final, cluster actual, solarhub actual.
   * Se validan si los datos son válidos y si el usuario es premium para permitir generar el pdf.
   * Con los datos obtenidos, se guardan en sessionStorage y se reciben en una nueva ventana para poder crearse el pdf
   */
    async generateReport() {
      this.print = true;
      this.printed = false;
      this.nReport.start_date = this.formatDate(this.nReport.start_date);
      this.nReport.end_date = this.formatDate(this.nReport.end_date);

      this.graphs = await submitReport(
        this.nReport.start_date,
        this.nReport.end_date,
        this.currentCluster[0].id,
        this.currentCluster[0].solarHubs[this.selectedHub].id
      );

      this.nReport.location = this.currentCluster[0].location;
      this.nReport.alias =
        this.currentCluster[0].solarHubs[this.selectedHub].name;
      if (
        (this.nReport.type == "L2" && this.isPremium) ||
        this.nReport.type == "L1"
      ) {
        sessionStorage.setItem("cCluster", JSON.stringify(this.nReport));
        sessionStorage.setItem(
          "idsPdf",
          JSON.stringify({
            idCluster: this.currentCluster[0].id,
            idSolarHub: this.selectedHub,
            idOkSolarHub: this.currentCluster[0].solarHubs[this.selectedHub].id,
          })
        );
      }

      if (
        (this.nReport.type == "L2" && this.isPremium) ||
        this.nReport.type == "L1"
      ) {
        sessionStorage.setItem("contador", 0);
        let routeData = this.$router.resolve({ name: "GHtmltoPdfView" });
        this.nReport.type = "";

        if (this.isSafari) {
          window.location.assign(routeData.href);
        } else {
          window.open(routeData.href, "_blank");
        }
      }
      this.printed = false;
      this.print = false;
    },

  /**
   * Método para dar formato a una fecha pasada por parámetro.
   * @param date
   */
    formatDate(date) {
      var d = new Date(date);
      return (date = [
        d.getFullYear(),
        ("0" + (d.getMonth() + 1)).slice(-2),
        ("0" + d.getDate()).slice(-2),
      ].join("-"));
    },

  /**
   * Método para crear un reporte programado, se envían los datos necesarios para crear un reporte programado.
   */
    async createReport() {
      this.createdReport = this.nReport;

      if (this.createdReport.sensors[0].name === "All") {
        this.createdReport.sensors = this.fValues.map((rv) => {
          return { name: rv.name };
        });
      }
      const data = await createProgramReport(
        this.createdReport,
        this.currentCluster[0].id,
        this.currentCluster[0].solarHubs[this.selectedHub]
      );
      this.nReport = {};
      let addedToReports = [];
      addedToReports = this.reportList;
      addedToReports.push(data);
      this.loadingTableReports();
    },
  /**
   * Método para eliminar el reporte programado de la tabla.
   * @param indexReport
   */
    deleteProgramReport(indexReport) {
      delReport(
        this.currentCluster[0].id,
        this.currentCluster[0].solarHubs[this.selectedHub].id,
        this.reportList[indexReport].id
      );
      let reportsFilter = [];
      reportsFilter = this.reportList.filter((report) => {
        return report.id !== this.reportList[indexReport].id;
      });
      this.updateReportList(reportsFilter);
    },
  /**
   * Método validador para crear un reporte generado
   * @param report
   */
    validateReport(report) {
      if (
        report.start_date !== undefined &&
        report.end_date !== undefined &&
        report.sensors.length > 0 &&
        report.hasOwnProperty("type") &&
        report.type !== ""
      ) {
        const startDate = new Date(report.start_date);
        const endDate = new Date(report.end_date);
        const currentDate = new Date();
        if (endDate < startDate || endDate > currentDate) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
  /**
   * Método validador para crear un reporte programado
   * @param report
   */
    validateProgram(report) {
      if (
        report.end_period !== undefined &&
        report.frequency !== undefined &&
        report.sensors.length > 0 &&
        report.hasOwnProperty("type") &&
        report.type !== ""
      ) {
        const end_period = new Date(report.end_period);
        const currentDate = new Date();

        if (end_period < currentDate) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
  /**
   * Método para cargar los datos en la tabla de reportes.
   */
    loadingTableReports() {
      this.loadReports({
        idCluster: this.currentCluster[0].id,
        idSolarHub: this.currentCluster[0].solarHubs[this.selectedHub].id,
      });
    },
  /**
   * Método para cargar la lista de solarhubs a partir del cluster y del solarhub seleccionado.
   */
    async loadingGraphs() {
      this.fValues = [];
      this.nReport.sensors = [];
      const data = await getListSolarHubs(
        this.currentCluster[0].id,
        this.currentCluster[0].solarHubs[this.selectedHub].id
      );

      this.sensorCounter = 0;
      this.graphs = await data[this.selectedHub].sensors;
      if (this.fValues.length == 0) {
        this.graphs.forEach((element) => {
          if (
            element.name !== "I_BATT_000" &&
            element.name !== "PWM_Led_000" &&
            element.name !== "SoC_000" &&
            element.influxId !== "T" &&
            element.influxId !== "RH"
          ) {
            if (this.sensorCounter == 0) {
              this.fValues.push({ name: "All" });
            }
            this.sensorCounter++;
            this.fValues.push({ name: element.name });
          }
        });
      }
    },
  },
  computed: {
    ...mapState("clusters", ["currentCluster", "idCluster"]),
    ...mapState("reports", ["reportList"]),
  /**
   * Obtiene el nombre de todos los sensores del reporte programado concreto.
   */
    getSensorNames() {
      var names = [];
      this.nReport.sensors.forEach((element) => {
        names.push(element.name);
      });
      return names.join(", ");
    },
  },
  watch: {
  /**
   * Ejecuta el método para cargar los reportes de la tabla y cargar la lista de sensores de los solarhubs cada vez que se selecciona un cluster o solarhub.
   */
    nReport: {
      handler(val) {
        this.$root.$emit("reportData", this.nReport);
      },
    },
    currentCluster: function () {
      this.loadingTableReports();
      this.loadingGraphs();
    },
    selectedHub: function () {
      this.loadingTableReports();
      this.loadingGraphs();
    },
  },
};
</script>



<style>
.regla-borde-report {
  margin-left: 5.1%;
  margin-right: 5.1%;
}
.tablewidth {
  width: 100%;
}
.datepicker-parent > div:first-child {
  display: flex;
  justify-content: flex-end;
}
.datepicker-parent > div:nth-child(2) {
  width: var(--picker-width);
}
.datepicker-parent > div:nth-child(3) {
  width: var(--picker-width);
}
.datepicker-parent > div:nth-child(4) {
  width: var(--picker-width);
}

.datepicker-width {
  width: 100%;
}

.cluster-gray {
  background-color: #2d2d2d;
}
.cluster-light {
  background-color: #cccccc;
}
.cluster-gray-border {
  border-color: #cccccc;
}
.reports-select-dark {
  padding-left: 8px;
  border: 1px solid #1a1a1a;
  background-color: #fff;
  color: #1a1a1a;
  border-radius: 3px;
}
.reports {
  padding-left: 8px;
  border: 1px solid #1a1a1a;
  background-color: #fff;
  color: #1a1a1a;
  border-radius: 3px;
}

::-webkit-calendar-picker-indicator {
  color: rgba(0, 0, 0, 0);
  opacity: 1;
  background-color: white;
  cursor: pointer;
  border-radius: 0%;
}

.table-pdf td,
.table-pdf th {
  border: 1px solid black;
}

.table-pdf td {
  padding-left: 10px;
}

.multiselect__placeholder {
  white-space: nowrap !important;
}
.multiselect {
  width: 200px !important;
}
.table-labels {
  background-color: #dbdbdb;
  color: black;
}
.table-values {
  background-color: white;
  color: black;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #2d2d2d;
  color: white;
  border-radius: 2px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
.multiselect__tag {
  background: rgb(251, 176, 59);
}
.multiselect__tags {
  min-height: 43px;
  border: solid 1px black;
}

.multiselect__option--highlight {
  background: rgb(251, 176, 59);
}

.multiselect__option--selected.multiselect__option--highlight {
  background: rgb(251, 176, 59);
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: rgb(181, 117, 15);
}
</style>
